import React from "react"
import ReactDOM from "react-dom"
import { hijackEffects } from "stop-runaway-react-effects"

import App from "./App"

if (process.env.NODE_ENV !== "production") {
  hijackEffects()
}

ReactDOM.render(<App />, document.getElementById("root"))
